module.exports = __webpack_public_path__ + "img/address-with-magnifier.91f963ec.png";